module.exports = __webpack_public_path__ + "static/media/chest-bronze-70x70-2x.31b3490e.png";